var React = require('react');

function TestTube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.3 13.7l.1.4v.4a1.5 1.5 0 0 1-.4 1 1.5 1.5 0 0 1-1 .5H2.5a1.5 1.5 0 0 1-1-.4 1.5 1.5 0 0 1-.3-1.9L5.7 6V2h-1V1h6v1h-1v3.7l.1.3 4.5 7.7zm-7.6-8c0 .3 0 .6-.2.8L4 11h7.6L9 6.5l-.2-.8V2h-2v3.7z","fill":"#000","fillRule":"evenodd"}));
}

TestTube.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = TestTube;

TestTube.default = TestTube;
